import { layout, media } from '@prisjakt/ui-base';
import styled from 'styled-components';

import { Column } from '@prisjakt/ui/list/variants';

export const GUTTER = layout.measurements.spacing100;

export const SearchResults = styled(Column)<{
  /**
   * Whether to set padding to 10px
   * @default false
   */
  smallerPadding?: boolean;
}>`
  padding: 0 ${p => (p.smallerPadding ? '10px' : GUTTER)};
  margin-bottom: ${GUTTER};
  margin-top: ${GUTTER};
`;

export const Section = styled.div``;

export const ModuleWrapper = styled.div`
  padding: 0 ${GUTTER};
`;

export const FilterWrapper = styled.div`
  ${media.mediumDown`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${layout.measurements.spacing050};
    margin-bottom: ${layout.measurements.spacing050};
  `}
`;

export const BodyGutter = styled.div`
  padding: 0 ${layout.measurements.spacing050};
`;

export const WrapBody = styled.div`
  margin: ${layout.measurements.spacing200} 0;
`;
